// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"vendors":"a3145355","webpack_sharing_consume_default_modifi_colors_modifi_colors-webpack_sharing_consume_default_m-2b0ce1":"3bd311be","webpack_sharing_consume_default_modifi_colors_modifi_colors-webpack_sharing_consume_default_m-f0b41e":"3bd311be"}[chunkId] + ".chunk.css";
};